// Спринты. Счётные строки: базовый ключ — форма «много», `_one` и `_few` — остальные.
const sprintsRu = {
  sprints: {
    sprint: "Спринт",
    backlog: "Бэклог",
    backlogTitle: "Бэклог",
    allSprints: "Все спринты",
    activeSprints: "Активные спринты",
    planASprint: "Запланировать спринт",
    next: "следующий",
    state: { planned: "Запланирован", active: "Активен", completed: "Завершён" },
    unit: { pts: "{{n}} SP", tasks: "задач: {{n}}" },
    points: "Стори-поинты",
    hours: "Часы",
    estimate: "Оценка",
    changeEstimate: "Изменить оценку",
    changeSprint: "Изменить спринт",
    quickPicks: "Быстрый выбор",
    pointsPlaceholder: "Любое число",
    pointsInvalid: "Введите число от 0 до 1000.",
    followsParent: "Как у родителя",
    unestimated: "Без оценки",
    loggedOfEstimate: "Затрачено / исходная оценка",
    notVerified: "Готова, не проверена",
    notVerifiedShort: "Не проверена",
    notVerifiedHint: "Готова, но тестирование ещё не пройдено",
    nNotVerified: "{{n}} не проверено",
    nRemaining: "осталось {{n}}",
    progress: "Прогресс спринта",
    progressText: "{{done}} / {{total}}",
    setCapacity: "Задать ёмкость",
    capacity: "Ёмкость",
    forecast_one: "Прогноз {{amount}} по последнему спринту",
    forecast_few: "Прогноз {{amount}} по последним {{count}} спринтам",
    forecast: "Прогноз {{amount}} по последним {{count}} спринтам",
    forecastBasis: {
      person_days: "Сделанное за доступный человеко-день в недавних спринтах × человеко-дни этого спринта",
      working_days: "Сделанное за рабочий день в недавних спринтах × рабочие дни этого спринта",
    },
    overForecast: "+{{n}} сверх прогноза",
    overCapacityBy: "+{{n}} сверх ёмкости",
    overBoth: "Больше прогноза и ёмкости",
    daysAround: "{{available}}/{{working}} дн.",
    daysOffHint: "Рабочие дни в этом спринте без выходных и отпусков",
    afterDaysOff: "{{capacity}} × {{available}}/{{working}} дн. = {{effective}}",
    daysOff: {
      title: "Нерабочие дни",
      titleFor: "Нерабочие дни — {{name}}",
      hint: "Отпуска и больничные. Они уменьшают ёмкость в запланированных спринтах всех проектов.",
      from: "С",
      to: "По",
      note: "Заметка",
      notePlaceholder: "Отпуск",
      add: "Добавить",
      edit: "Изменить",
      save: "Сохранить",
      remove: "Удалить",
      none: "Нерабочих дней не запланировано.",
      merged: "Пересекающиеся периоды объединяются в один.",
      button: "Нерабочие дни",
      nDays_one: "{{count}} день",
      nDays_few: "{{count}} дня",
      nDays: "{{count}} дней",
    },
    capacityOf: "{{total}} / {{capacity}}",
    over: "+{{n}} сверх",
    overCapacity: "Сверх ёмкости",
    overall: "Вся команда",
    capacityFor: "Ёмкость: {{name}}",
    noCap: "Без лимита",
    capacityInvalid: "Ёмкость — число от 0 и больше.",
    capacityHint: {
      points: "В стори-поинтах. Пустое поле — без лимита.",
      hours: "В часах. Пустое поле — без лимита.",
      none: "В задачах. Пустое поле — без лимита.",
    },
    perPerson: "Нагрузка по людям",
    startsIn: "Начнётся через {{count}} дней",
    startsIn_one: "Начнётся через {{count}} день",
    startsIn_few: "Начнётся через {{count}} дня",
    startsToday: "Начинается сегодня",
    daysLeft: "Осталось {{count}} дней",
    daysLeft_one: "Остался {{count}} день",
    daysLeft_few: "Осталось {{count}} дня",
    lastDay: "Последний день",
    endedAgo: "Закончился {{count}} дней назад",
    endedAgo_one: "Закончился {{count}} день назад",
    endedAgo_few: "Закончился {{count}} дня назад",
    nTasks: "{{count}} задач",
    nTasks_one: "{{count}} задача",
    nTasks_few: "{{count}} задачи",
    nUnestimated: "Без оценки: {{count}}",
    nSelected: "Выбрано: {{count}}",
    doneOf: "Готово {{done}} из {{total}}",
    filtered: "с фильтром",
    groupBySprint: "По спринту",
    sortBySprint: "Спринт",

    createSprint: "Создать спринт",
    selection: "Выбранные задачи",
    moveTo: "Переместить в",
    moveTaskTo: "Переместить {{key}} в…",
    selectTask: "Выбрать {{key}}",
    clearSelection: "Снять выбор",
    noSprintsTitle: "Спринтов пока нет",
    noSprintsBody: "Создайте спринт и перетащите в него задачи из бэклога ниже.",
    noSprintsViewer: "Спринты здесь планирует менеджер проекта.",
    emptySprint: "В спринте пока нет задач.",
    emptySprintDrop: "Перетащите сюда задачи из бэклога или выберите «Переместить в» у задачи.",
    emptySprintMove: "Выберите «Переместить в» у задачи, чтобы добавить её в этот спринт.",
    emptyBacklog: "Бэклог пуст: все открытые задачи в спринтах.",
    addGoal: "Добавить цель",
    actionsFor: "Другие действия: {{name}}",
    edit: "Изменить спринт",
    currentAndPlanned: "Текущие и запланированные",
    completedSprints: "Завершённые",
    openBacklog: "Открыть бэклог",

    name: "Название",
    goal: "Цель",
    goalHint: "Чего команда хочет добиться за этот спринт.",
    startDate: "Начало",
    endDate: "Конец",
    endBeforeStart: "Дата окончания не может быть раньше начала.",
    create: "Создать спринт",
    createTitle: "Новый спринт",
    editTitle: "Изменить {{name}}",
    created: "{{name}} создан",
    saved: "Спринт сохранён",
    start: "Начать спринт",
    startTitle: "Начать {{name}}",
    started: "{{name}} начат",
    anotherActive: "{{name}} ещё активен. Завершите его, прежде чем начинать другой спринт.",
    emptyWarning: "В спринте пока нет задач. Его можно начать и добавить задачи позже.",
    startSummary: "{{count}} задач, обязательство: {{total}}.",
    startSummary_one: "{{count}} задача, обязательство: {{total}}.",
    startSummary_few: "{{count}} задачи, обязательство: {{total}}.",
    complete: "Завершить спринт",
    completeTitle: "Завершить {{name}}",
    completed: "{{name}} завершён",
    allDone: "Все задачи спринта готовы. После завершения отчёт фиксируется.",
    unfinishedIntro: "Не завершено {{count}} задач:",
    unfinishedIntro_one: "Не завершена {{count}} задача:",
    unfinishedIntro_few: "Не завершено {{count}} задачи:",
    moveUnfinished: "Куда перенести незавершённые задачи",
    destNext: "Следующий спринт: {{name}}",
    destNextNone: "Следующий запланированный спринт",
    destNextNoneHint: "Запланированного спринта нет. Выберите новый спринт.",
    destNew: "Новый спринт",
    destNewHint: "Создаётся сейчас, сразу после этого.",
    destBacklog: "Бэклог",
    destBacklogHint: "Вне спринтов, чтобы спланировать позже.",
    subtasksFollow: "Подзадачи переносятся вместе с родительской задачей.",
    deleteTitle: "Удалить {{name}}?",
    deleteBody: "Его задачи ({{count}}) вернутся в бэклог. Это нельзя отменить.",
    deleteBody_one: "Его задачи ({{count}}) вернутся в бэклог. Это нельзя отменить.",
    deleted: "{{name}} удалён",

    completedBanner: "Спринт завершён {{date}}. Доска только для просмотра.",
    openReport: "Открыть отчёт",
    openSprint: "Открыть спринт",
    report: "Отчёт",

    reportTitle: "Отчёт: {{name}}",
    tabReport: "Отчёт",
    tabRetro: "Ретроспектива",
    reportPlannedTitle: "Отчёт появится, когда спринт начнётся",
    reportPlannedBody: "После старта здесь будут обязательство, диаграмма сгорания и изменения объёма.",
    committed: "Обязательство",
    completedLabel: "Выполнено",
    completedSplit: "{{committed}} из плана + {{added}} добавлено",
    added: "Добавлено",
    removed: "Убрано",
    estimateChange: "Оценки {{n}}",
    notVerifiedTiles: "Готовые задачи, тестирование которых не пройдено",
    burndown: "Диаграмма сгорания",
    burndownPoints: "Стори-поинты в открытых задачах по дням.",
    burndownHours: "Оставшееся время по дням.",
    burndownTasks: "Открытые задачи по дням.",
    burndownDayOne: "Первый день: осталось {{initial}}. Линия заполняется день за днём.",
    remainingLine: "Осталось",
    idealLine: "Идеально",
    scopeChange: "Изменение объёма",
    listCompleted: "Выполнено",
    listNotCompleted: "Не выполнено",
    listRemoved: "Убрано из спринта",
    listAdded: "Добавлено после старта",
    listNotVerified: "Готово, не проверено",
    listCarriedMore: "Переносились больше одного раза",
    listEmpty: "Нет",
    addedMark: "добавлена",
    stillHere: "в этом спринте",
    timesCarried: "перенесена {{count}} раз",
    timesCarried_few: "перенесена {{count}} раза",
    timeByPerson: "Затраченное время по людям",
    timeTotal: "Затрачено {{logged}} при оценке {{estimate}}",
    noTimeLogged: "В этом спринте время не списывали.",
    velocity: "Скорость команды",
    velocityAverage: "В среднем выполнено: {{n}} (последние 6 завершённых спринтов)",
    velocityNone: "Скорость появится, когда спринты будут завершены.",
    velocityOne: "Пока завершён один спринт: скорость станет понятнее через несколько.",

    retro: { well: "Что получилось", improve: "Что не получилось", action: "Действия" },
    retroHint: { well: "Продолжаем так делать.", improve: "Что тормозило команду.", action: "Конкретные шаги, у каждого — ответственный." },
    retroAdd: { well: "Что получилось…", improve: "Что не получилось…", action: "Действие…" },
    retroIntro: "Добавлять заметки может любой в команде. Изменения сохраняются сразу, даже после завершения спринта.",
    retroReadOnly: "Заметки команды по этому спринту.",
    retroEmpty: "Пока пусто.",
    retroDelete: "Удалить заметку",
    retroDone: "Сделано",
    retroOwner: "Назначить ответственного",
    retroNoOwner: "Без ответственного",
  },
  timer: {
    section: "Время",
    original: "Исходная оценка",
    loggedLabel: "Затрачено",
    remaining: "Осталось",
    setByHand: "задано вручную",
    setRemaining: "Задать оставшееся время",
    automatic: "Автоматически",
    barLabel: "Затрачено {{logged}}, осталось {{remaining}}",
    subtaskNote: "Время по подзадаче идёт в оценку родительской задачи.",
    logTime: "Списать время",
    logTitle: "Списать время на {{key}}",
    editTitle: "Изменить время на {{key}}",
    stoppedTitle: "Таймер на {{key}} остановлен",
    stoppedBody: "Время сохранено. При необходимости поправьте его.",
    keep: "Оставить как есть",
    duration: "Затрачено",
    durationHint: "Например: 2h 30m, 45m или 1.5h",
    durationInvalid: "Пишите так: 2h 30m, 45m или 1.5h.",
    durationRange: "От 1 минуты до 24 часов.",
    date: "Дата",
    dateHint: "Сегодня, если не указать",
    note: "Заметка",
    logged: "Списано {{time}}",
    entrySaved: "Запись времени сохранена",
    editEntry: "Изменить запись",
    deleteEntry: "Удалить запись",
    deleteTitle: "Удалить эту запись времени?",
    deleteBody: "{{time}} за {{date}} будет удалено.",
    review: "Проверить",
    reviewHint: "Забытый таймер остановился сам через 12 часов. Проверьте время и сохраните.",
    start: "Запустить таймер",
    stop: "Остановить таймер",
    startOn: "Запустить таймер на {{key}}",
    stopOn: "Остановить таймер на {{key}}",
    running: "Таймер на {{key}}: {{time}}",
  },
  sprintSettings: {
    scrumTitle: "Scrum",
    scrumIntro: "Спринты, бэклог, оценки, учёт времени, покер планирования, стендап и выходные дни.",
    scrumLabel: "Использовать Scrum в этом проекте",
    scrumHint: "Если выключить, всё это скроется, а автоматические спринты встанут на паузу. Ничего не удаляется: при включении всё вернётся.",
    timezoneTitle: "Часовой пояс",
    timezoneIntro: "Этот часовой пояс используют повторяющиеся задачи и графики потока.",
    title: "Спринты",
    intro: "Как проект оценивает работу и ведёт спринты.",
    unit: "Единица оценки",
    units: { points: "Стори-поинты", hours: "Часы", none: "Нет (считать задачи)" },
    unitHint: "Итоги спринта, ёмкость и диаграмма сгорания считаются в этой единице.",
    unitLocked: "Завершите активный спринт, чтобы сменить единицу.",
    length: "Длина спринта",
    weeks: "{{count}} недель",
    weeks_one: "{{count}} неделя",
    weeks_few: "{{count}} недели",
    timezone: "Часовой пояс",
    timezoneHint: "Дни спринта начинаются и заканчиваются в полночь по этому поясу.",
    timezoneSuggested: "Взят из браузера. Сохраните, чтобы применить.",
    timezoneUnknown: "Выберите часовой пояс из списка.",
    workingDays: "Рабочие дни",
    workingDaysHint: "В остальные дни идеальная линия сгорания не опускается.",
    workingDaysNone: "Выберите хотя бы один рабочий день.",
    day: { mon: "Пн", tue: "Вт", wed: "Ср", thu: "Чт", fri: "Пт", sat: "Сб", sun: "Вс" },
    dayLong: { mon: "Понедельник", tue: "Вторник", wed: "Среда", thu: "Четверг", fri: "Пятница", sat: "Суббота", sun: "Воскресенье" },
    timeLogging: "Учёт времени",
    timeLoggingHint: "Списание времени на задачи и таймер. Оставшееся время уменьшается по мере списания.",
    timeLoggingHoursOnly: "Доступно, когда единица оценки — часы.",
    auto: "Автоматические спринты",
    autoHint: "Mixla завершает спринт в дату окончания, переносит незавершённые задачи в следующий и запускает его.",
    autoWeekday: "Спринты начинаются в",
    autoLength: "Каждый спринт длится {{count}} недель (длина спринта выше).",
    autoLength_one: "Каждый спринт длится {{count}} неделю (длина спринта выше).",
    autoLength_few: "Каждый спринт длится {{count}} недели (длина спринта выше).",
    autoWillPlan: "После сохранения сразу будет запланирован {{name}}.",
    autoKeeps: "Mixla держит следующий спринт запланированным.",
    unsaved: "Есть несохранённые изменения",
  },
};

export default sprintsRu;
